import TrainingDropDown from "../Training/TrainingDropDown.js";
import Courses from "../Courses/Courses.js";
import FreeLearningHoverBox from "../HeaderResources/FreeLearningHoverBox.js";
import AIEngineerDropDown from "../AIEngineer/AIEngineerDropDown.js";
import RenaissanceCourseDropdown from "../RenaissanceCourseDropdown/RenaissanceCourseDropdown.js";
const NavLinks = (props) => {
    return (
        <div className="header-nav-links-container">
            <AIEngineerDropDown className="new-header-nav-link" />
            <RenaissanceCourseDropdown className="new-header-nav-link" />
            <Courses className="new-header-nav-link" />
            <FreeLearningHoverBox className="new-header-nav-link" />
            {/* <TrainingDropDown className="new-header-nav-link"/> */}
            <div className="nav-backdrop"></div>
            {/* <HeaderCoursesDropDown />

            <a
                className={`${GTM_TRACKER.SUCCESS_STORIES} header-nav-link`}
                target="_blank"
                rel="noreferrer"
                href={`${process.env.REACT_APP_FRONTEND_MAIN_URL}crack-coding-interviews/stories`}
            >
                Success Stories
            </a>

            <a
                className={`${GTM_TRACKER.HIRE_FROM_US} header-nav-link`}
                target="_blank"
                rel="noreferrer"
                href="https://programmingpathshala.com/hire-from-us#"
            >
                Hire From Us
            </a>

            <a
                className={`${GTM_TRACKER.CAMPUS_PROGRAM} header-nav-link`}
                target="_blank"
                rel="noreferrer"
                href="https://programmingpathshala.com/campus-program#"
            >
                Campus Program
            </a>

            <a
                className={`${GTM_TRACKER.BLOGS} header-nav-link`}
                target="_blank"
                rel="noreferrer"
                href="https://blogs.programmingpathshala.com/"
            >
                Blogs
            </a>

            <a
                className={`${GTM_TRACKER.EVENTS} header-nav-link`}
                target="_blank"
                rel="noreferrer"
                href="https://events.programmingpathshala.com/"
            >
                Events
            </a> */}
        </div>
    );
};

export default NavLinks;
